'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dom = {
  boom: 'data-boom',
  calculate: 'data-calc-link',
  calculatedText: 'data-calc-done-text'
};

var buildExplosionWrapper = function buildExplosionWrapper(button) {
  var wrapper = document.createElement('div');
  wrapper.classList.add('animation-wrapper');
  button.parentNode.insertBefore(wrapper, button);
  wrapper.appendChild(button);

  // build particles
  var particleColor = button.dataset.particleColor;
  var particleWrapper = document.createElement('div');
  for (var i = 0; i < 50; i++) {
    var particle = document.createElement('div');
    particle.classList.add('particle');
    particle.style.backgroundColor = particleColor;
    particleWrapper.appendChild(particle);
  }
  wrapper.appendChild(particleWrapper);
};

var explode = function explode(event) {
  var button = event.currentTarget;

  if (button.classList.contains('boom')) return;
  button.classList.add('boom');

  var animationTimer = setInterval(function () {
    clearInterval(animationTimer);
    button.classList.remove('boom');
  }, 600);
};

var setupBoomListeners = function setupBoomListeners() {
  var explosionWrappers = document.querySelectorAll('.animation-wrapper');
  explosionWrappers.forEach(function (wrapper) {
    wrapper.addEventListener('click', explode);
  });
};

var animateCheckout = function animateCheckout(event) {
  event.preventDefault();
  var button = event.currentTarget;

  // prevent multiple clicks
  if (button.dataset.hasAnimated == "true") return;
  button.dataset.hasAnimated = true;

  var hasYotpo = false;
  var yotpoIsApplied = false;
  var $yotpoCart = $('.customer-logged-in [data-yotpo-loyalty-cart-wrapper]');
  var pitcoinCost = $yotpoCart.data('cost');

  if ($yotpoCart.length && pitcoinCost) {
    hasYotpo = true;
    $('.yotpo-coupons-redemption-widget button[data-cost="' + pitcoinCost + '"]').click();
    var checkYotpoApplied = window.setInterval(function () {
      var yotpoReward = window.localStorage.getItem('yotpo-loyalty-reward');
      if (yotpoReward) {
        yotpoIsApplied = true;
        window.clearInterval(checkYotpoApplied);
      }
    }, 250);
  }

  var duration = Number(button.dataset.calcDuration);
  var started = new Date().getTime();
  var buttonText = button.dataset.calcDoneText || 'Hell Yeah Brother!';

  var redirect = function redirect() {
    if (new Date().getTime() - started > duration) {
      // stop the loop and send to page
      window.clearInterval(animationTimer);
      button.textContent = buttonText;

      // allow user some time to read message before leaving
      window.setTimeout(function () {
        window.location.href = '/checkout';
        // in case user cancels location change, re-enable link
        button.setAttribute('href', '/checkout');
      }, 500);
    } else {
      // build new 16-bit string
      var binaryString = '';
      for (var i = 0; i < 16; i++) {
        var digit = Math.random() * 10 < 5 ? 0 : 1;
        binaryString += '' + digit;
      }
      button.classList.add('animating');
      button.textContent = binaryString;
    }
  };

  var animationTimer = window.setInterval(function () {
    if (hasYotpo && yotpoIsApplied) {
      redirect();
    } else if (!hasYotpo) {
      redirect();
    }
  }, 200); // rate of digits changing
};

/**
 * Setup any animated buttons
 */
var setupExplodingButtons = function setupExplodingButtons() {
  var explodingButtons = document.querySelectorAll('[' + dom.boom + ']');

  explodingButtons.forEach(function (button) {
    // enable effect here (build necessary markup)
    buildExplosionWrapper(button);
  });
  setupBoomListeners();
};

var setupAnimatedCheckout = function setupAnimatedCheckout() {
  var calculatedCheckoutButtons = document.querySelectorAll('[' + dom.calculate + ']');
  calculatedCheckoutButtons.forEach(function (button) {
    button.removeAttribute('href'); // prevent actual link behavior
    button.addEventListener('click', animateCheckout);
  });
};

$(document).on('click', '.yotpo-coupons-redemption-widget button', function () {
  var checkConfirmBtn = window.setInterval(function () {
    var $button = $('.yotpo-redemption-confirmation-option-confirm button');
    if ($button.length) {
      $button.click();
      window.clearInterval(checkConfirmBtn);
    }
  }, 250);
});

$(document).on('click', '.yotpo-redemption-confirmation-option-confirm button', function () {
  var checkCode = window.setInterval(function () {
    var $code = $('.yotpo-copy-code-text');
    if ($code.length) {
      var yotpoCode = $code.text().trim();
      window.localStorage.setItem('yotpo-loyalty-reward', yotpoCode);
      var existingPerks = +window.localStorage.getItem('yotpo-perks-redeemed');
      window.localStorage.setItem('yotpo-final-perks', existingPerks + 1);
      window.clearInterval(checkCode);
    }
  }, 250);
});

exports.default = {
  setupExplodingButtons: setupExplodingButtons,
  setupAnimatedCheckout: setupAnimatedCheckout
};